export default __webpack_public_path__ + "static/media/reward.fb64c25d.png";